import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosComman";
import NuDateFormat from "../../utils/NuDate";

function DashboardTableView({ url = "", title = "", link = "" }) {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  async function getFunction() {
    await axiosInstance
      .get(`${url}`)
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  useEffect(() => {
    getFunction();
  }, [url]);

  const handleNavigate = (item) => {
    const id = item?.id || item?.row_id;
    if (id && link) {
      navigate(link, { state: { openItemViewId: id } });
    }
  };

  const getDateValue = (item) => {
    if (!item) return null;
    if (typeof item === "string" || typeof item === "number") return item;
    return (
      item.date ||
      item.schedule_date ||
      item.mom_date ||
      item.created_at ||
      Object.values(item).find((v) => typeof v === "string" && v.includes("-"))
    );
  };

  return (
    <div className=" w-full h-full p-4 bg-white shadow-main rounded-md overflow-hidden">
      <Link to={link}>
        <p className="text-xs 2xl:text-sm text-[#6E6985] pb-1">{title}</p>
      </Link>
      <div className=" w-full relative  h-full ">
        <div className=" w-full grid grid-cols-2 gap-x-4 sticky top-0">
          <div className="w-full h-8 bg-[#F2E9FF] rounded-md p-1.5">
            <p className="text-xs 2xl:text-sm text-[#7030A0] pl-2 pb-5">
              Previous Date
            </p>
          </div>

          <div className="w-full h-8 bg-[#F2E9FF] rounded-md p-1.5">
            <p className="text-xs 2xl:text-sm text-[#7030A0] pl-2 pb-5">
              Upcoming Date
            </p>
          </div>
        </div>
        <div className=" w-full grid grid-cols-2 gap-x-4 h-full overflow-y-auto">
          <div className="w-full">
            {data?.previous_date?.map((i, idx) => (
              <p
                className="py-2 pl-5 text-xs 2xl:text-sm text-[#8C87A6] cursor-pointer hover:text-primary transition-colors hover:underline"
                key={idx}
                onClick={() => handleNavigate(i)}
              >
                {(
                  <NuDateFormat value={getDateValue(i)} format="DD-MMM-YYYY" />
                ) || "-"}
              </p>
            ))}
          </div>
          <div className="w-full">
            {data?.upcoming_date?.map((i, idx) => (
              <p
                className="py-2 pl-5 text-xs 2xl:text-sm text-[#8C87A6] cursor-pointer hover:text-primary transition-colors hover:underline"
                key={idx}
                onClick={() => handleNavigate(i)}
              >
                {(
                  <NuDateFormat value={getDateValue(i)} format="DD-MMM-YYYY" />
                ) || "-"}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardTableView;
